import Tastet from '../tastet.js';

const STATES = {
  OPEN: 'open',
};

export default class Modal extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      alias: 'modal',
      root: null,
      openSelector: false,
      closeSelector: '[data-action="close"]',
      urlHash: false,
      autoOpen: false,        // cookie key (or true) to auto-open once per cooldown
      autoOpenDelay: 0,       // ms to wait before auto-opening
      autoOpenDays: 1,        // cooldown window, in days
    });

    var html = this.$(
      `<div element="wrap" class="modal &--modal">
            <div element="background" class="&--overlay"></div>
            <div element="inner" class="&--inner">
            </div>
        </div>`.replace(/\&/g, data.alias)
    );

    this.extract(html, this);

    if (data.root) {
      this.$wrap.append(data.root);
    } else {
      this.$wrap.insertBefore(this.$element);
    }

    this.$element.removeClass(this.classname).addClass(data.alias + '--content');
    this.$element.appendTo(this.$inner);
    this.$inner = this.$element;
    this.$element = this.$wrap;
  }

  addEvents() {
    var data = this.get();
    this.on(this.$background, 'click', this.background_onClick);

    if (data.openSelector) {
      this.on(this.$body, 'click', { delegate: data.openSelector, callback: this.open_onClick });
    }
    if (data.closeSelector) {
      this.on(this.$body, 'click', { delegate: data.closeSelector, callback: this.close_onClick });
    }
    if (this.$close) {
      this.on(this.$close, 'click', this.close_onClick);
    }

    // Check URL hash to auto-open modal
    if (data.urlHash) {
      this._checkUrlHash();
      this.on(window, 'hashchange', this._onHashChange);
    }

    // Auto-open once per cooldown window (e.g. newsletter capture popup)
    if (data.autoOpen) {
      this._maybeAutoOpen();
    }
  }

  // URL hash handling
  _checkUrlHash() {
    var data = this.get();
    var hash = window.location.hash.replace('#', '');
    if (hash && hash === data.urlHash) {
      this.open();
    }
  }

  _onHashChange() {
    var data = this.get();
    var hash = window.location.hash.replace('#', '');
    if (hash && hash === data.urlHash) {
      this.open();
    } else if (this.isOpen() && !hash) {
      this.close();
    }
  }

  // Auto-open handling
  // Cookie-gated so the modal pops at most once per `autoOpenDays` window. The
  // cookie is written when the modal actually opens, not on page load: a visitor
  // who never sees it (iframe, hash-linked, another modal in the way) still gets
  // a chance on the next visit instead of silently burning the cooldown.
  _maybeAutoOpen() {
    var data = this.get();

    // Embedded contexts (previews, oEmbed cards) must never pop a modal.
    if (window.self !== window.top) return;

    // The visitor asked for this modal explicitly via #hash — _checkUrlHash()
    // already opened it, so don't double-open and don't spend the cooldown.
    if (data.urlHash && window.location.hash === '#' + data.urlHash) return;

    if (this.utils.storage.get(this._autoOpenKey(), false, 'cookie')) return;

    this.wait(data.autoOpenDelay || 0, this._autoOpen, 'autoOpen');
  }

  _autoOpen() {
    if (this.isOpen()) return;

    // Something grabbed the screen while we were waiting — the region gate on a
    // first visit, or the user opening this modal by hand. Leave the cooldown
    // untouched and try again on the next page load.
    if (document.querySelector('.modal.is-open')) return;

    this.utils.storage.set(this._autoOpenKey(), true, 'cookie', this.get('autoOpenDays') + 'day');

    // silent: an unrequested popup must not rewrite the URL or push a history
    // entry, otherwise Back closes the popup instead of leaving the page.
    this.open({ silent: true });
  }

  _autoOpenKey() {
    var autoOpen = this.get('autoOpen');
    return 'tastet_auto_open_' + (autoOpen === true ? this.classname : autoOpen);
  }

  // events ----------------------------------------------------------------------------------------------------------
  background_onClick() {
    this.close();
  }

  close_onClick(e) {
    var parent = this.utils.dom.closest(e.target, '[view="' + this.classname + '"]');
    if (parent && !this.$inner.is(parent)) return;
    this.close();
  }

  open_onClick() {
    this.open();
  }

  // methods ---------------------------------------------------------------------------------------------------------
  isOpen() {
    return this.state(STATES.OPEN) === true;
  }

  open(options) {
    if (!this.isOpen()) {
      this.trigger('open');
    }

    this.state(STATES.OPEN, true);

    // Update URL hash if configured — skipped when the open wasn't user-initiated
    var data = this.get();
    if (data.urlHash && !(options && options.silent)) {
      history.pushState(null, '', '#' + data.urlHash);
    }

    this.scan(this.$inner, { lazy: true });
  }

  close() {
    if (this.isOpen()) {
      this.trigger('close');
    }

    this.state(STATES.OPEN, false);

    // Remove URL hash if configured
    var data = this.get();
    if (data.urlHash && window.location.hash === '#' + data.urlHash) {
      history.pushState(null, '', window.location.pathname + window.location.search);
    }
  }
}
